
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"preserveAspectRatio":"xMaxYMid meet","viewBox":"0 0 910 512","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M431.598 446.159s-173.019-111.887-194.646-227.61C215.325 102.826 319.86 52.362 381.134 73.951c61.276 21.586 72.09 76.009 72.09 76.009s43.255-103.739 129.767-80.848c86.506 22.884 122.555 140.308 64.965 213.172-57.589 72.864-216.272 163.882-216.272 163.882","fill":"#FA512C"}}),_c('path',{attrs:{"d":"M381.743 195.748a13.354 13.354 0 01-8.206 12.361 13.351 13.351 0 01-17.486-17.404 13.349 13.349 0 0112.322-8.264c3.541 0 6.936 1.406 9.44 3.909a13.354 13.354 0 013.909 9.44M533.552 198.239a13.354 13.354 0 01-8.24 12.333 13.346 13.346 0 01-18.201-9.729 13.343 13.343 0 0113.092-15.953c3.54 0 6.936 1.406 9.44 3.909a13.354 13.354 0 013.909 9.44zM444.34 326.578h-2.095c-36.088-.839-66.706-22.487-81.942-57.904l11.484-4.945c13.245 30.784 39.692 49.604 70.751 50.295 31.434.755 60.019-17.498 74.67-47.572l11.253 5.471c-16.492 33.865-48.555 54.633-84.06 54.633","fill":"#fff"}})])
          )
        }
      }
    